import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Theme,
  TypographyVariant,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import moment from 'moment';
import { getTimeText } from '../services/datetime';
interface Props {
  post: Post;
  overlay?: boolean;
  hideDetail?: boolean;
  dateOnly?: boolean;
  imageHeight?: number;
  sideBySide?: boolean;
  titleSize?: TypographyVariant;
  icon?: React.ReactNode;
  type: postTypes;
  onClickVideo?: (url: string) => void;
}
interface StyleProps {
  imageUrl: string;
  overlay?: boolean;
  hideDetail?: boolean;
  imageHeight?: number;
  sideBySide?: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  clampText: {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
  content: {
    backgroundColor: ({ overlay }) => (overlay ? '#0006' : '#534E64'),
    bottom: 0,
    minHeight: 70,
    padding: 8,
    position: ({ overlay }) => (overlay ? 'absolute' : 'static'),
    width: '100%',
  },
  datetime: {
    opacity: 0.75,
  },
  overlayIcon: {
    alignItems: 'center',
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  post: {
    display: 'flex',
    flexDirection: ({ sideBySide }) => (sideBySide ? 'row' : 'column'),
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
  postTitle: {
    cursor: 'pointer',
  },
  thumbnail: {
    backgroundImage: ({ imageUrl }) => `url('${imageUrl}')`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: ({ overlay, imageHeight }) => imageHeight || (overlay ? 320 : 160),
    position: 'relative',
    width: '100%',
    cursor: 'pointer',
  },
}));

const PostItem: React.FC<Props> = ({
  post,
  overlay,
  hideDetail,
  dateOnly,
  imageHeight,
  sideBySide,
  titleSize,
  icon,
  type,
  onClickVideo,
}) => {
  const history = useHistory();
  const {
    clampText,
    content,
    datetime,
    overlayIcon,
    post: postStyle,
    postTitle,
    thumbnail,
  } = useStyles({
    imageUrl: post.imageUrl !== '' ? post.imageUrl : '/images/placeholder.png',
    overlay,
    hideDetail,
    imageHeight,
    sideBySide,
  });

  const handleClick = () => {
    switch (type) {
      case 'event':
      case 'article':
        history.push(`/post/${type}/${post.id}`, post);
        break;
      case 'video':
        if (onClickVideo) onClickVideo(post.link);
        break;
      case 'document':
      default:
        break;
    }
  };
  return (
    <div className={postStyle}>
      <div className={thumbnail} onClick={handleClick}>
        {icon && <div className={overlayIcon}>{icon}</div>}
      </div>
      <div className={content}>
        <Typography
          className={clsx(postTitle, clampText)}
          variant={titleSize || 'body1'}
          onClick={handleClick}
          noWrap
        >
          {post.title}
        </Typography>
        {!hideDetail && (
          <>
            <Box height={16} />
            <Typography variant='caption' className={datetime}>
              {getTimeText(moment(post.date))}
            </Typography>
            <Box height={16} />
            <Typography noWrap className={clampText}>
              {post.excerpt}&nbsp;
            </Typography>
            <Box height={16} />
            <Box display='flex' justifyContent='flex-end'>
              <Button onClick={handleClick}>
                <Typography color='secondary'>อ่านต่อ &gt;&gt;</Typography>
              </Button>
            </Box>
          </>
        )}
        {dateOnly && (
          <Typography variant='caption' className={datetime}>
            {getTimeText(moment(post.date))}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default PostItem;
